import React, { useEffect, useState } from "react";
import query from "jquery";
import { Link, NavLink, useNavigate } from "react-router-dom";
import CurrencySelection from "./CurrencySelection";
import CartHorizontal from "./Cart";
import Cart from "./Cart";
import { useTranslation } from "react-i18next";
import { useSettingsStore } from "../stores/settingsStore";
import SearchProducts from "./SearchProducts";
import Profile from "./Profile";
import { useCategoriesStore } from "../stores/categoriesStore";
import { useAuth } from "../contexts/AuthContext";

const HeaderTwo = ({ category }) => {

  const navigate = useNavigate();
  const settings = useSettingsStore((state) => state.settings)
  const categories = useCategoriesStore((state) => state.categories)
  const selectedCategoryId = useCategoriesStore((state) => state.selectedCategoryId)
  const handleCategoryClick = useCategoriesStore((state) => state.handleCategoryClick)
  const { user, logout } = useAuth();

  const {t} = useTranslation()

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);

  // Set the default language
  const [selectedLanguage, setSelectedLanguage] = useState("Eng");
  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  // Set the default currency
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
  };

  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleMenuClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };

  // Search control support
  const [activeSearch, setActiveSearch] = useState(false);
  const handleSearchToggle = () => {
    setActiveSearch(!activeSearch);
  };

  // category control support
  const [activeCategory, setActiveCategory] = useState(false);
  const handleCategoryToggle = () => {
    setActiveCategory(!activeCategory);
  };
  const [activeIndexCat, setActiveIndexCat] = useState(null);
  const handleCatClick = (index) => {
    setActiveIndexCat(activeIndexCat === index ? null : index);
  };

  // Function to handle category click on mobile and close the drawer
  const handleCategoryClickMobile = (categoryId) => {
    handleCategoryClick(categoryId, null, null, null, navigate);
    handleCategoryToggle(); // Close the drawer after selecting a category
  };

  return (
    <>
      <div className='overlay' />
      <div
        className={`side-overlay ${(menuActive || activeCategory) && "show"}`}
      />
      {/* ==================== Search Box Start Here ==================== */}

      <div className={`search-box ${activeSearch && "active"}`}>
        <button
          onClick={handleSearchToggle}
          type='button'
          className='w-48 h-48 m-16 text-2xl text-white border border-gray-100 search-box__close position-absolute inset-block-start-0 inset-inline-end-0 rounded-circle flex-center hover-text-gray-800 hover-bg-white transition-1'
        >
          <i className='ph ph-x' />
        </button>
        <div className='container tw-flex tw-justify-center'>
          <SearchProducts 
            style="style-two" 
            className="tw-py-8" 
            onSubmitSuccess={handleSearchToggle} 
            width="w-100"
          />
        </div>
      </div>
      {/* ==================== Search Box End Here ==================== */}
      {/* ==================== Mobile Menu Start Here ==================== */}
      <div
        className={`mobile-menu scroll-sm d-lg-none d-block ${
          menuActive && "active"
        }`}
      >
        <button
          onClick={() => {
            handleMenuToggle();
            setActiveIndex(null);
          }}
          type='button'
          className='close-button'
        >
          <i className='ph ph-x' />{" "}
        </button>
        <div className='mobile-menu__inner'>
          <Link to='/' className='mobile-menu__logo'>
              <img className="tw-h-12 tw-w-auto" src={settings.store_logo} alt='Logo' />
          </Link>
          <div className='mobile-menu__menu'>
            {/* Nav Menu Start */}
            <ul className='nav-menu flex-align nav-menu--mobile'>
              <li className='on-hover-item nav-menu__item'>
                <Link to='/' className='nav-menu__link'>
                  {t('common.home')}
                </Link>
              </li>
              <li className='on-hover-item nav-menu__item'>
                <Link to='/shop' className='nav-menu__link'>
                  {t('common.store')}
                </Link>
              </li>
            </ul>
            {/* Nav Menu End */}
            {/* Auth Links Start */}
            <div className="tw-border-gray-200 tw-mt-5">
              <h6 className="tw-pr-4 tw-text-sm tw-font-semibold tw-text-gray-600">{t('common.account')}</h6>
              <ul className="nav-menu nav-menu--mobile">
                {user ? (
                  <>
                    <li className="nav-menu__item">
                      <Link to="/profile" className="nav-menu__link">
                        {t('profile.settings')}
                      </Link>
                    </li>
                    <li className="nav-menu__item">
                      <Link to="/orders" className="nav-menu__link">
                        {t('orders.your_orders')}
                      </Link>
                    </li>
                    <li className="nav-menu__item">
                      <button 
                        onClick={() => logout()} 
                        className="nav-menu__link tw-w-full tw-text-left tw-text-red-600">
                        {t('common.logout')}
                      </button>
                    </li>
                  </>
                ) : (
                  <li className="nav-menu__item">
                    <Link to="/login" className="nav-menu__link">
                      {t('common.login')}
                    </Link>
                  </li>
                )}
              </ul>
            </div>
            {/* Auth Links End */}
          </div>
        </div>
      </div>
      {/* ==================== Mobile Menu End Here ==================== */}
      {/* ======================= Middle Header Two Start ========================= */}
      <header className='header-middle style-two bg-color-neutral'>
        <div className='container container-lg'>
          <nav className='header-inner flex-between'>
            {/* Logo Start */}
            <div className='logo'>
              <Link to='/' className='link'>
                <img className="tw-h-12 lg:tw-h-20 tw-w-auto" src={settings.store_logo} alt='Logo' />
              </Link>
            </div>
            {/* Logo End  */}
            {/* form Category Start */}
            <div className='gap-16 flex-align'>
              <div className='select-dropdown-for-home-two d-lg-none d-block'>
                {/* Dropdown Select Start */}
                <ul className='flex-wrap header-top__right style-two flex-align'>
                  <CurrencySelection></CurrencySelection>
                  <Cart iconClass="tw-text-white"></Cart>
                </ul>
                {/* Dropdown Select End */}
              </div>
              <SearchProducts style="style-two" visibleBreakpoints="d-none d-lg-block" width="tw-w-[500px]"/>
            </div>
            {/* form Category start */}
            {/* Header Middle Right start */}
            <div className='header-right flex-align d-lg-block d-none'>
              <div className='flex-wrap gap-32 header-two-activities flex-align'>
                <button
                  type='button'
                  className='gap-4 flex-align search-icon d-lg-none d-flex item-hover-two'
                >
                  <span className='text-2xl text-white d-flex position-relative item-hover__text'>
                    <i className='ph ph-magnifying-glass' />
                  </span>
                </button>
                <Profile style="style-two" />
                <Cart label={t('common.cart')} direction="vertical" labelClass="tw-text-white" iconClass="tw-text-white"></Cart>
              </div>
            </div>
            {/* Header Middle Right End  */}
          </nav>
        </div>
      </header>
      {/* ======================= Middle Header Two End ========================= */}
      {/* ==================== Header Two Start Here ==================== */}
      <header
        className={`header bg-white border-bottom border-gray-100 ${
          scroll && "fixed-header"
        }`}
      >
        <div className='container container-lg'>
          <nav className='gap-8 header-inner d-flex justify-content-between'>
            <div className='flex-align menu-category-wrapper'>
              {/* Category Dropdown Start */}
              <div
                className={`category-two ${
                  category === false ? "d-block" : "d-none"
                } `}
              >
                <button
                  onClick={handleCategoryToggle}
                  type='button'
                  className='gap-8 p-16 text-white category__button flex-align fw-medium bg-main-two-600'
                >
                  <span className='text-2xl icon d-xs-flex d-none'>
                    <i className='ph ph-dots-nine' />
                  </span>
                  <span className='d-sm-flex d-none'>{t('categories.all')}</span>
                  <span className='text-xl arrow-icon d-flex'>
                    <i className='ph ph-caret-down' />
                  </span>
                </button>
                <div
                  className={`responsive-dropdown cat common-dropdown d-lg-none d-block nav-submenu p-0 submenus-submenu-wrapper shadow-none border border-gray-100 ${
                    activeCategory && "active"
                  }`}
                >
                  <button
                    onClick={() => {
                      handleCategoryToggle();
                      setActiveIndexCat(null);
                    }}
                    type='button'
                    className='mt-4 text-xl close-responsive-dropdown rounded-circle position-absolute inset-inline-end-0 inset-block-start-0 me-8 d-lg-none d-flex'
                  >
                    <i className='ph ph-x' />{" "}
                  </button>
                  <div className='px-16 logo d-lg-none d-block'>
                    <Link to='/' className='link'>
                      <img className="tw-h-12 tw-w-auto" src={settings.store_logo} alt='Logo' />
                    </Link>
                  </div>
                  <ul className='p-0 py-8 overflow-y-auto scroll-sm w-300 max-h-400'>
                    <li>
                      <div 
                        onClick={() => handleCategoryClickMobile(null)}
                        className={`gap-8 px-16 tw-py-1 text-15 flex-align rounded-0 tw-cursor-pointer item-hover-two ${selectedCategoryId === null ? 'text-main-600' : 'text-gray-500'}`}>
                        <span className="item-hover__text">{t('categories.all')}</span>
                      </div>
                    </li>
                    {
                      categories && categories.map(c => {
                        return (
                          <li key={`header-category-${c.id}`}>
                            <div 
                              onClick={() => handleCategoryClickMobile(c.id)}
                              className={`gap-8 px-16 tw-py-1 text-15 flex-align rounded-0 tw-cursor-pointer item-hover-two ${selectedCategoryId === c.id ? 'text-main-600' : 'text-gray-500'}`}>
                              <span className="item-hover__text">{c.name}</span>
                            </div>
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
              <div
                className={`category main  on-hover-item bg-main-600 text-white ${
                  category === true ? "d-block" : "d-none"
                }`}
              >
                <button
                  type='button'
                  className='gap-8 p-16 text-white border-gray-100 category__button flex-align fw-medium border-end border-start'
                >
                  <span className='text-2xl icon d-xs-flex d-none'>
                    <i className='ph ph-dots-nine' />
                  </span>
                  <span className='d-sm-flex d-none'>{selectedCategoryId ? categories.find(c => c.id === selectedCategoryId)?.name : t('categories.all')}</span>
                  <span className='text-xl arrow-icon d-flex'>
                    <i className='ph ph-caret-down' />
                  </span>
                </button>
                <div className='p-0 responsive-dropdown on-hover-dropdown common-dropdown nav-submenu submenus-submenu-wrapper'>
                  <button
                    type='button'
                    className='mt-4 text-xl close-responsive-dropdown rounded-circle position-absolute inset-inline-end-0 inset-block-start-0 me-8 d-lg-none d-flex'
                  >
                    <i className='ph ph-x' />{" "}
                  </button>
                  <div className='px-16 logo d-lg-none d-block'>
                    <Link to='/' className='link'>
                      <img className="tw-h-12 tw-w-auto" src={settings.store_logo} alt='Logo' />
                    </Link>
                  </div>
                  <ul className='p-0 py-8 overflow-y-auto scroll-sm w-300 max-h-400'>
                    <li>
                      <div 
                        onClick={() => handleCategoryClickMobile(null)}
                        className={`gap-8 px-16 py-12 text-15 flex-align rounded-0 tw-cursor-pointer item-hover-two ${selectedCategoryId === null ? 'text-main-600' : 'text-gray-500'}`}>
                        <span className="item-hover__text">{t('categories.all')}</span>
                      </div>
                    </li>
                    {
                      categories && categories.map(c => {
                        return (
                          <li key={`header-category-${c.id}`}>
                            <div 
                              onClick={() => handleCategoryClickMobile(c.id)}
                              className={`gap-8 px-16 py-12 text-15 flex-align rounded-0 tw-cursor-pointer item-hover-two ${selectedCategoryId === c.id ? 'text-main-600' : 'text-gray-500'}`}>
                              <span className="item-hover__text">{c.name}</span>
                            </div>
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
              {/* Category Dropdown End  */}
              {/* Menu Start  */}
              <div className='header-menu d-lg-block d-none'>
                {/* Nav Menu Start */}
                <ul className='nav-menu flex-align '>
                  <li className='on-hover-item nav-menu__item'>
                    <Link to='/' className='nav-menu__link'>
                      {t('common.home')}
                    </Link>
                  </li>
                  <li className='on-hover-item nav-menu__item'>
                    <Link to='/shop' className='nav-menu__link'>
                      {t('common.store')}
                    </Link>
                  </li>
                </ul>
                {/* Nav Menu End */}
              </div>
              {/* Menu End  */}
            </div>
            {/* Header Right start */}
            <div className='header-right flex-align'>
              <div className='select-dropdown-for-home-two d-lg-block d-none'>
                {/* Dropdown Select Start */}
                <ul className='flex-wrap header-top__right style-two flex-align'>
                  <CurrencySelection classElement="text-heading"></CurrencySelection>
                  {
                    scroll && (
                      <Cart></Cart>
                    )
                  }
                </ul>
                {/* Dropdown Select End */}
              </div>
              <div className='me-8 d-lg-none d-block'>
                <div className='flex-wrap gap-32 header-two-activities flex-align'>
                  <button
                    onClick={handleSearchToggle}
                    type='button'
                    className='gap-4 flex-align search-icon d-lg-none d-flex item-hover-two'
                  >
                    <span className='text-2xl text-white d-flex position-relative item-hover__text'>
                      <i className='ph ph-magnifying-glass' />
                    </span>
                  </button>
                </div>
              </div>
              <button
                onClick={handleMenuToggle}
                type='button'
                className='text-4xl text-gray-800 toggle-mobileMenu d-lg-none ms-3n d-flex'
              >
                {" "}
                <i className='ph ph-list' />{" "}
              </button>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}
    </>
  );
};

export default HeaderTwo;
